<template>
  <div>
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
</template>

<script>

export default {
  name: 'LogoutRedirect',
  data() {
    return {
      errors: null,
      logo: '../../../assets/logo.png',
      callback_url : null,
    }
  },
  async mounted() {
    // console.log("??????????????????????????????????????")
    // http://localhost:8080/auth/logout?callback_url=https%3A%2F%2Fgoogle.com
    const callback_url = this.$route.query?.callback_url ?? null;
    this.callback_url = callback_url;
    // console.log("callback_url=============", callback_url);
    this.validateLogout()
  },
  methods: {
    validateLogout() {
      // console.log('Logout')
      this.$AuthenticationApp.clearDataLogout().then(() => {
        //this.$emit('close')
        this.displayLogout = false;
        var callback_url = ''
        if (this.callback_url) {
          callback_url = '?callback_url='+this.callback_url
        }
        // this.$router.push('/auth/login'+callback_url)
        window.location.href = '/auth/login'+callback_url
      })
    },
    
  }
}
</script>

